<template>
    <div class="search-group layout11" :class="isMobileSize ? 'mobile' : ''">
        <div v-if="searchGroupTabs.length > 1" class="tab-header">
            <ul class="tab-header-ul">
                <li
                    :class="`option ${activeIndex === index ? 'active' : ''}`"
                    @click="changeType(index)"
                    :key="item.value"
                    v-for="(item, index) in searchGroupTabs"
                    v-html="item.name"
                ></li>
            </ul>
        </div>
        <div class="tab-body">
            <div
                v-for="(item, index) in searchGroupTabs"
                :key="item.id"
                :class="`tab-content ${activeIndex === index ? 'active' : ''}`"
            >
                <component
                    :is="searchBar"
                    v-if="item.inputComponentType === 'searchBar'"
                    v-show="activeIndex === index"
                    :placeholder="searchGroupConfig['placeholder-search']"
                    :submitText="item.submitText"
                    :searchButton="searchButton"
                />
                <address-input
                    v-if="item.inputComponentType === 'addressInput'"
                    v-show="activeIndex === index"
                    :placeholder="
                        searchGroupConfig[
                            item.id === 1
                                ? 'placeholder-sell'
                                : 'placeholder-eval'
                        ]
                    "
                    v-model:searchText="searchText"
                    :submitText="item.submitText"
                    :submitStyle="searchButtonStyle"
                    :chooseSuggestionAutoSubmit="false"
                    :mobileScroll="false"
                    icon="icon-search"
                    theme="layout11"
                    @submitAddress="
                        (address, data, callback) =>
                            submitAddress(
                                { address, data, callback },
                                index,
                                item.submitType,
                                item.submitUrl
                            )
                    "
                />
            </div>
        </div>
        <div
            v-if="agreementData && agreementData.agreement"
            class="agreement-container"
        >
            <a
                :href="agreementData.agreementUrl || ''"
                class="agreement"
                target="_blank"
                rel="noopener"
            >{{ agreementData.agreement }}</a
            >
        </div>
    </div>
</template>

<script>
import common from '../search-group';
import mixinsSearchBar from './mixins-search-bar';
import AddressInput from '../../../components/address-input/standard.vue';
export default {
    mixins: [common, mixinsSearchBar],
    data: function() {
        return {
            offset: [0, 3],
            activeIndex: 0
        };
    },
    components: {
        AddressInput
    },
    mounted() {},
    methods: {
        changeType(i) {
            this.activeIndex = i;
        }
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        searchButtonStyle() {
            if (this.searchButton) {
                return {
                    color: this.searchButton.textColor,
                    background: this.searchButton.backgroundColor
                };
            }
            return {};
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '@/theme/mixin.scss';
.search-group.layout11 {
    --input-height: 70px;
    --radius: 100px;
    width: 100%;

    ul {
        padding: 0;
        margin: 0;
        li {
            list-style: none;
        }
    }
    .tab-header {
        display: flex;
        height: 62px;
    }
    .tab-header-ul {
        margin: 0 auto;
        height: 100%;
        display: inline-flex;
        pointer-events: auto;
        .option {
            min-width: 149px;
            height: 100%;
            line-height: 62px;
            padding: 0 20px;
            font-size: 16px;
            font-weight: 400;
            text-align: center;
            color: var(--g-btn-color);
            opacity: 0.7;
            cursor: pointer;
            position: relative;
            &.active {
                font-weight: 700;
                opacity: 1;
            }
            &:hover {
                font-weight: 700;
            }
        }
    }

    .tab-body {
        width: 100%;
        height: var(--input-height);
        background: rgba(255, 255, 255, 0.1);
        border: 0.5px solid rgba(255, 255, 255, 0.3);
        border-radius: var(--radius);
        backdrop-filter: blur(10px);
        pointer-events: auto;
        .tab-content {
            width: 100%;
            display: none;
            &.active {
                display: block;
            }

            .address-input.standard {
                height: var(--input-height);
                width: 100%;
                border-radius: var(--radius);
                box-shadow: none;
                align-items: center;
                @include media-600 {
                    background-color: transparent;
                    &.standard .left-box .icon-search {
                        display: none;
                    }
                }
                .left-box {
                    height: 100%;
                    input {
                        box-sizing: border-box;
                        height: 100%;
                        padding: 0 20px;
                        background-color: transparent !important;
                        font-size: 16px;
                        font-weight: 400;
                        color: var(--g-primary-color);
                        border: none;
                        outline: none;
                        &::placeholder {
                            color: rgba(255, 255, 255, 1);
                            opacity: 0.5;
                        }
                        @include media-600 {
                            padding-left: 10px;
                            padding-right: 10px;
                            font-size: 14px;
                        }
                    }
                    .close-box .icon-search-close::before {
                        background-color: transparent;
                    }
                }
                .right-box {
                    height: 50px;
                    width: 120px;
                    margin: 0 10px;
                    .submit-btn {
                        @include color-button-hover();
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        border-radius: var(--radius);
                        padding: 0;
                        line-height: 50px;
                        text-align: center;
                        font-size: 16px;
                        font-weight: 400;
                        color: var(--g-btn-color);
                        background-color: var(--g-btn-background);
                        border: none;
                        .iconfont {
                            display: none;
                        }
                    }
                    @include media-800 {
                        display: block;
                        width: 50px;
                        padding: 0;
                        text-align: center;

                        .submit-btn {
                            width: 100%;
                            .iconfont {
                                font-size: 24px;
                                display: block;
                                font-weight: 600;
                            }
                            .submit {
                                display: none;
                            }
                        }
                    }
                }
            }
        }
    }
    .agreement-container {
        width: 100%;
        margin-top: 20px;
        .agreement {
            width: 100%;
            font-size: 12px;
            text-align: center;
            @include webkitBox(3);
            line-height: 14px;
            color: #fff;
            &:hover {
                @include color-hover();
                @include media-800 {
                    color: #fff;
                }
            }
        }
    }
    @include media-800 {
        width: 100%;
        .tab-header {
            width: 100%;
        }
        .tab-header-ul {
            width: 100%;
            display: flex;
            justify-content: center;
            gap: 50px;
            .option {
                flex: none;
                padding: 0;
                min-width: auto;
            }
        }
    }
}
</style>
